import { computed, unref } from 'vue'
import defaultAvatar from '~/assets/store/home/face.png'
import { normalizeChinaMobile } from '~/utils/phone'

/**
 * @description 商城个人中心用户展示字段，供个人中心和 Header 登录态菜单共用。
 * @param {import('vue').Ref<Object|null|undefined> | Object|null|undefined} userInfoSource
 * @param {{ isReady?: import('vue').Ref<boolean> | boolean }} [options]
 * @returns {{ avatarUrl: import('vue').ComputedRef<string>, nickname: import('vue').ComputedRef<string>, phone: import('vue').ComputedRef<string> }}
 */
export function useStoreAccountProfileDisplay(userInfoSource, options = {}) {
  const isReady = computed(() => {
    if (options.isReady === undefined) return true
    return Boolean(unref(options.isReady))
  })

  const userInfo = computed(() => (isReady.value ? unref(userInfoSource) : null))

  const avatarUrl = computed(() => {
    if (!isReady.value) return ''
    let url = userInfo.value?.head_icon || userInfo.value?.icon || userInfo.value?.avatar || ''
    url = String(url).replace(/.*proxy\?/, '/proxy/')
    if (url === '/proxy/' || !url) return defaultAvatar
    return url
  })

  const nickname = computed(() => {
    if (!isReady.value) return ''
    return (
      userInfo.value?.nick_name ||
      userInfo.value?.legalPersonName ||
      normalizeChinaMobile(
        userInfo.value?.account_name || userInfo.value?.phone || userInfo.value?.mobile || ''
      )
    )
  })

  const phone = computed(() => {
    if (!isReady.value) return ''
    const raw = normalizeChinaMobile(
      userInfo.value?.phone || userInfo.value?.mobile || userInfo.value?.account_name || ''
    )
    if (!raw || raw.length < 11) return raw
    return `${raw.slice(0, 3)}****${raw.slice(-4)}`
  })

  return {
    avatarUrl,
    nickname,
    phone,
  }
}
